import { AgentDto } from './../../core/services/area.model';
import { PagedRequest } from './paged-request.model';
import { Agent } from './transactions-model';
// Generated by https://quicktype.io

export interface AggregatorModel {
	totalPages: number;
	responseCode: string;
	aggregators: Aggregator[];
}

export interface Aggregator {
	id: number;
	emailAddress: string;
	mobileNumber: string;
	businessName: string;
	bankId: number;
	bankAccountNo: string;
	bankVerificationNo: string;
	addressLineOne: string;
	addressLineTwo: string;
	city: string;
	localGovernmentId: number;
	stateId: number;
	countryId: number;
	status: string;
	kycVerificationStatus: string;
	lastModifiedOn: string;
	nextOfKin: NextOfKin;
	state?: any;
}

export interface AggregatorAgentModel {
	agents: Agent[];
	responseCode: string;
	totalPages: number;
}

export interface NextOfKin {
}

export class AggregatorRequestModel extends PagedRequest {
	keyword: any;
	status: any;

	constructor(obj?) {
		super(obj);

		this.keyword = obj && obj.keyword || '';
		this.status = obj && obj.status || '';
	}
}

export class AreaUpdateRequestModel {
	aggregatorId: number;
	areaGrids: string[];
}

// Generated by https://quicktype.io

export class AssignAreaRequestModel {
	areaName: string;
	aggregatorId: number;
	areaGrids: string[];
	validateCheckSum: boolean;
	aggregatorData?: AggregatorData;
	gridsData?: GridsData;

	constructor(obj?) {
		this.gridsData = obj && new GridsData(obj);
		this.aggregatorData = obj && new AggregatorData(obj);
	}
}

export class AggregatorData {
	noOfAgents: number;
	numberOfTerminals: number;
	currentDepositValue: number;
	currentDepositVolume: number;
	currentDepositEarnings: number;
	currentWithdrawalValue: number;
	currentWithdrawalVolume: number;
	currentWithdrawalEarnings: number;

	constructor(obj) {
		this.noOfAgents = obj && obj.noOfAgents;
		this.numberOfTerminals = obj && obj.numberOfTerminals;
		this.currentDepositValue = obj && obj.currentDepositValue;
		this.currentDepositVolume = obj && obj.currentDepositVolume;
		this.currentDepositEarnings = obj && obj.currentDepositEarnings;
		this.currentWithdrawalValue = obj && obj.currentWithdrawalValue;
		this.currentWithdrawalVolume = obj && obj.currentWithdrawalVolume;
		this.currentWithdrawalEarnings = obj && obj.currentWithdrawalEarnings;
	}
}

export class GridsData {
	noOfAgents: number;
	numberOfTerminals: number;
	estimatedDepositValue: number;
	estimatedDepositVolume: number;
	estimatedDepositEarnings: number;
	estimatedWithdrawalValue: number;
	estimatedWithdrawalVolume: number;
	estimatedWithdrawalEarnings: number;

	constructor(obj) {
		this.noOfAgents = obj && obj.estimatedNumberOfAgents;
		this.numberOfTerminals = obj && obj.estimatedNumberOfTerminals;
		this.estimatedDepositValue = obj && obj.estimatedDepositValue;
		this.estimatedDepositVolume = obj && obj.estimatedDepositVolume;
		this.estimatedWithdrawalValue = obj && obj.estimatedWithdrawalValue;
		this.estimatedDepositEarnings = obj && obj.estimatedDepositEarnings;
		this.estimatedWithdrawalVolume = obj && obj.estimatedWithdrawalVolume;
		this.estimatedWithdrawalEarnings = obj && obj.estimatedWithdrawalEarnings;
	}
}


// Generated by https://quicktype.io


export enum ResponseCode {
	processing = '200002',
}

export interface Path {
	lat: number;
	lng: number;
}

export enum TerminalAreaGridStatus {
	Unassigned = 'UNASSIGNED',
	Assigned = 'ASSIGNED'
}



// Generated by https://quicktype.io

export interface EligibleAggregatorModel {
	aggregatorId: number;
	aggregatorName: string;
	mapped: boolean;
}

export interface EligibleAggregatorObj {
	id: number;
	businessName: string;
	code: string;
}


// Generated by https://quicktype.io

export interface FeesModel {
	responseCode: string;
	fees: Fees;
}

export interface Fees {
	agentFee: null;
	baseAggregatorRevenue: null;
	extraAggregatorRevenue: null;
}


// Generated by https://quicktype.io

export interface AgentTerminalInfoModel {
	responseCode: string;
	terminals: Terminal[];
}

export interface Terminal {
	id: number;
	createdOn: string;
	lastModifiedOn: string;
	terminalId: string;
	ptspKeyConfiguration: null;
	merchantId: MerchantID;
	terminalOwner: null;
	lastValidKeyExchangeTime: null;
	transactingViaTms: boolean;
	hibernateTime: string;
	status: string;
}

export interface MerchantID {
	id: number;
	createdOn: string;
	lastModifiedOn: string;
	cardAcceptorId: string;
	withdrawalProcessorType: string;
	acquirer: Acquirer;
	ptsp: Ptsp;
	receivableAccount: EAccount;
	processingFeeAccount: null;
	disputePayableAccount: EAccount;
	businessScheme: BusinessScheme;
	refundBusinessScheme: BusinessScheme;
	bankRefundBusinessScheme: BusinessScheme;
	bankDisputeRefundExpenseAccount: EAccount;
	bankDisputeRefundPayableAccount: EAccount;
	status: string;
}

export interface Acquirer {
	id: number;
	createdOn: string;
	lastModifiedOn: string;
	name: string;
	generalLedger: null;
	status: string;
}

export interface EAccount {
	id: number;
	createdOn: string;
	lastModifiedOn: string;
	name: string;
	accountId: number;
	code: string;
	status: string;
}

export interface BusinessScheme {
	id: number;
	createdOn: string;
	lastModifiedOn: string;
	name: string;
	code: string;
	enableBatchPosting: boolean;
}

export interface Ptsp {
	id: number;
	createdOn: string;
	lastModifiedOn: string;
	name: string;
	code: string;
	receivableAccount: EAccount;
	moniepointShareReceivableAccount: null;
	lastValidKeyExchangeTime: null;
	ptspKeyConfigurations: PtspKeyConfiguration[];
	status: string;
}

export interface PtspKeyConfiguration {
	id: number;
	createdOn: string;
	lastModifiedOn: string;
	ptspKey: string;
	nibssIP: string;
	nibssPort: string;
	nonSSLHostIP: null;
	nonSSLHostPort: null;
	nibssEnableSSL: boolean;
	enableSecureKeyDownload: boolean;
	callHomeIP: string;
	callHomePort: string;
	name: string;
	callHomeEnableSSL: boolean;
	lastValidKeyExchangeTime: null;
	enableTMSValidation: boolean;
	status: string;
}

// Generated by https://quicktype.io

export interface AssignedSerialNoModel {
	responseCode: string;
	records: SerialRecord[];
}

export interface SerialRecord {
	id: number;
	serialNo: string;
	maximumAggregatorFee: number;
	activationAmount: number;
	insuranceFee: number;
	range: null;
	terminalCondition: string;
	hasFeeWaiver?: boolean;
}


// Generated by https://quicktype.io

export interface AgentLocationModel {
	responseCode: string;
	agentLocations: AgentLocation[];
}

export interface AgentLocation {
	id: number;
	locationName: string;
	estimatedFootFallPerHour: string;
	addressLineOne: string;
	addressLineTwo: string;
	listOfCurrentlyUsedPlatforms: string[];
	withdrawalValueCommitment: number;
	depositValueCommitment: number;
	locationPhysicallyVisitedByAggregator: boolean;
	localGovernmentId: number;
	stateId: number;
	countryId: number;
}

// Generated by https://quicktype.io

export class AssignTerminalRequestModel {
	id: number;
	agentId: number;
	aggregatorFee: number;
	agentLocationId: number;
}

export class NewAssignTerminalRequestModel {
	id: number;
	agentId: number;
	aggregatorFee: number;
	moniepointFeaturesId: [];
}


export class AddLocationRequestModel {
	locationName: string;
	estimatedFootFallPerHour: number;
	localGovernmentId: number;
	addressLineOne: string;
	addressLineTwo: string;
	listOfCurrentlyUsedPlatforms: string;
	withdrawalValueCommitment: number;
	depositValueCommitment: number;
	locationPhysicallyVisitedByAggregator: boolean;
	agentId: number;
	locationVideo: any;
	endOfDayPicture: any;
}

export class AgentRegistrationRequestModel {
	username: string;
	firstName: string;
	dateOfBirth: number;
	gender: string;
	lastName: string;
	emailAddress: string;
	mobileNumber: number;
	meansOfIdentification: string;
	idNumber: number;
	issueDate: number;
	expirationDate: number;
	occupation: number;
	jobTitle: string;
	businessName: string;
	bankId: number;
	bankAccountNo: number;
	bankAccountName: string;
	bankVerificationNo: number;
	enableInstantSettlement: boolean;
	addressLineOne: number;
	mothersMaidenName: number;
	city: string;
	localGovernmentId: number;
	nextOfKinFullName: string;
	nextOfKinRelationship: string;
	nextOfKinEmailAddress: string;
	nextOfKinPhoneNumber: any;
	nextOfKinAddressLineOne: string;
	nextOfKinAddressLineTwo: string;
	nextOfKinCity: string;
	nextOfKinCountryId: number;
	nextOfKinStateId: number;
	nextOfKinLocalGovernmentId: number;
	agentType: string;
	identificationDocument: File;
	utilityBillDocument: File;
	businessDocument: File;
	otherDocument: File;
	passport: File;
	signature: File;

	constructor(obj?) {
		this.username = obj && obj.username;
		this.firstName = obj && obj.firstName;
		this.dateOfBirth = obj && obj.dateOfBirth && obj.dateOfBirth.valueOf();
		this.gender = obj && obj.gender && obj.gender.toUpperCase();
		this.lastName = obj && obj.lastName;
		this.emailAddress = obj && obj.emailAddress;
		this.mobileNumber = obj && obj.mobileNumber;
		this.meansOfIdentification = obj && obj.meansOfIdentification;
		this.idNumber = obj && obj.idNumber;
		this.issueDate = obj && obj.issueDate && obj.issueDate.valueOf();
		this.expirationDate = obj && obj.expirationDate && obj.expirationDate.valueOf();
		this.occupation = obj && obj.occupation;
		this.jobTitle = obj && obj.jobTitle;
		this.businessName = obj && obj.businessName;
		this.bankId = obj && obj.bankId;
		this.bankAccountNo = obj && obj.bankAccountNo;
		this.bankAccountName = obj && obj.bankAccountName;
		this.bankVerificationNo = obj && obj.bankVerificationNo;
		this.enableInstantSettlement = obj && obj.enableInstantSettlement || true;
		this.addressLineOne = obj && obj.addressLineOne;
		this.mothersMaidenName = obj && obj.mothersMaidenName;
		this.city = obj && obj.city || '';
		this.localGovernmentId = obj && obj.localGovernmentId;
		this.nextOfKinFullName = obj && obj.nextOfKinFullName;
		this.nextOfKinRelationship = obj && obj.nextOfKinRelationship;
		this.nextOfKinEmailAddress = obj && obj.nextOfKinEmailAddress;
		this.nextOfKinPhoneNumber = obj && obj.nextOfKinPhoneNumber;
		this.nextOfKinAddressLineOne = obj && obj.nextOfKinAddressLineOne;
		this.nextOfKinAddressLineTwo = obj && obj.nextOfKinAddressLineTwo || '';
		this.nextOfKinCity = obj && obj.nextOfKinCity || '';
		this.nextOfKinCountryId = obj && obj.nextOfKinCountryId;
		this.nextOfKinStateId = obj && obj.nextOfKinStateId;
		this.nextOfKinLocalGovernmentId = obj && obj.nextOfKinLocalGovernmentId;
		this.agentType = obj && obj.agentType;
		this.identificationDocument = obj && obj.identificationDocument;
		this.utilityBillDocument = obj && obj.utilityBillDocument;
		this.businessDocument = obj && obj.businessDocument;
		this.otherDocument = obj && obj.otherDocument;
		this.passport = obj && obj.passport;
		this.signature = obj && obj.signature;
	}
}


// Generated by https://quicktype.io

// export interface RelationshipManagerTerminalsModel {
// 	serialNumber: string;
// 	terminalRange: TerminalRange;
// 	coordinate: Coordinate;
// 	color?: string;
// 	showWindow?: boolean;
// 	agentName?: string;
// 	aggregatorName?: string;
// 	aggregatorState?: string;
// }

// Generated by https://quicktype.io

export interface RelationshipManagerTerminalsModel {
	responseCode: string;
	records: TerminalRecord[];
}

export interface TerminalRecord {
	serialNumber: string;
	terminalRange: TerminalRange;
	agentName?: string;
	aggregatorName?: string;
	aggregatorState?: string;
	latitude: number;
	longitude: number;
	showWindow: boolean;
	color?: string;
}


export interface Coordinate {
	lat: number;
	lng: number;
}

export enum TerminalRange {
	InRange = 'IN_RANGE',
	OutOfRange = 'OUT_OF_RANGE',
	NoGridFitting = 'NO_GRID_FITTING',
	NoAreaManager = 'NO_AREA_MANAGER',
	NoArea = 'NO_AREA',
	NoGridInArea = 'NO_GRID_IN_AREA'
}


// Generated by https://quicktype.io

export interface SuperAggregatorAreaGridModel {
	code?: string;
	responseCode?: string;
	description?: string;
	responseMessage?: string;
	terminalAreaAssignmentMetaData: TerminalAreaAssignmentMetaData;
	grids: Grid[];
}

export interface Grid {
	gridId: number;
	gridCode: string;
	gridSize: number;
	localGovernmentArea: string;
	boundaries: Boundaries;
	areaAssignmentStatus: TerminalAreaGridStatus;
	areaManagerCode: null;
	areaManagerState: null;
	areaManagerBusinessName: null;
	terminals: TerminalInGrid[];
	path: Path[];
	selected: boolean;
	hasValue: boolean;
	backgroundColor: string;
	showWindow: boolean;
	poly: any;
	areaManagerId: any;
}

export interface Boundaries {
	northEast: Coords;
	southWest: Coords;
}

export interface Coords {
	latitude: number;
	longitude: number;
}

export interface TerminalInGrid {
	hardwareTerminalId: number;
	hardwareTerminalSerial: string;
	terminalID: string;
	gridId: string;
	latitude: number;
	longitude: number;
	accuracy: number;
	agentId: number;
	agentName: null | string;
	agentState: string | null;
	relationshipManagerId: number;
	relationshipManagerName: null | string;
	relationshipManagerState: string | null;
	withdrawalVolume: number;
	withdrawalValue: number;
	depositVolume: number;
	depositValue: number;
	relationshipManagerWithdrawalEarnings: number;
	relationshipManagerDepositEarnings: number;
	biDataPeriodInDays: number;
	showWindow: boolean;
	show: boolean;
}

export enum State {
	Abia = 'Abia',
	AkwaIbom = 'AkwaIbom',
	Anambra = 'Anambra',
	Bayelsa = 'Bayelsa',
	Benue = 'Benue',
	CrossRiver = 'Cross River',
	Delta = 'Delta',
	EDO = 'Edo',
	Ebonyi = 'Ebonyi',
	Ekiti = 'Ekiti',
	Enugu = 'Enugu',
	Fct = 'FCT',
	Imo = 'Imo',
	Jigawa = 'Jigawa',
	Kaduna = 'Kaduna',
	Kano = 'Kano',
	Kogi = 'Kogi',
	Kwara = 'Kwara',
	Lagos = 'Lagos',
	Niger = 'Niger',
	Ogun = 'Ogun',
	Ondo = 'Ondo',
	Osun = 'Osun',
	Oyo = 'Oyo',
	Plateau = 'Plateau',
	Rivers = 'Rivers',
	Taraba = 'Taraba',
	Zamfara = 'Zamfara',
}

export interface TerminalAreaAssignmentMetaData {
	totalEarningThreshold: number;
	terminalMarkerDecimalOffset: number;
}


// Generated by https://quicktype.io

export interface ElligibleAggregatorObjectModel {
	responseCode: string;
	records: EligibleAggregatorModel[];
}

